import { Injectable } from "@angular/core";
import {
  AgEntityNameAcnAbnComponent
} from "@shared/components/grid/ag-cells/common/ag-entity-name-acn-abn/ag-entity-name-acn-abn.component";
import { BaseGridService } from "@shared/services/base/base-grid.service";
import { ColDef } from "ag-grid-community";

@Injectable()
export class BulkChangesGridService extends BaseGridService {
  override setColDefs(actionColumn: ColDef) {
    const colDefs: ColDef[] = [
      {
        headerName: 'Name',
        field: 'name',
        sort: 'asc',
        flex: 1,
        cellRenderer: AgEntityNameAcnAbnComponent,
        menuTabs: []
      },
      actionColumn
    ];

    this.colDefs.set(colDefs);
  }
}
